import { useAuthStore } from 'stores/authStore';
import useSelectedRetailerProfile from './useSelectedRetailerProfile';

const useAvailableRegions = () => {
  const regions = useAuthStore((state) => state.user?.admin_details?.brand?.regions) || [];
  const retailerRegion = useSelectedRetailerProfile()?.region;

  if (retailerRegion) {
    return [retailerRegion];
  }

  return regions;
};

export default useAvailableRegions;
